(function(){
    'use strict';
    
    jcu_js_v1.fn.initApplyButtonListener = function(){
        var applyButton = document.querySelector('.jcu-v1__utils__apply');
        
        if (applyButton !== null) {
            
            applyButton.addEventListener('click', function(e) {
                e.preventDefault();

                var accordion = document.getElementById('how-to-apply');

                if (accordion !== null) {

                    var scrollTop = accordion.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 80;
                    
                    /*window.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth',
                    });*/
                    //$(document).scrollTop(scrollTop);
                    $('html, body').stop().animate({ scrollTop: scrollTop }, 500);
                    var accordionButton = accordion.querySelector('.jcu-v1__accordion__btn');

                    if (accordionButton.getAttribute('aria-expanded') === 'false') {
                        accordionButton.click();
                    }

                    setTimeout(function() {
                        accordionButton.focus();
                    }, 10);
                    
                }
                
            });
        }
    }

    jcu_js_v1.fn.scrollTo = function(element, to, duration) {
        if (duration <= 0) return;
        var difference = to - element.scrollTop;
        var perTick = difference / duration * 10;
    
        setTimeout(function() {
            element.scrollTop = element.scrollTop + perTick;
            if (element.scrollTop === to) return;
            jcu_js_v1.fn.scrollTo(element, to, duration - 10);
        }, 10);
    }
    
    jcu_js_v1.fn.initApplyButtonListener();


}());
